import { Accessibility } from './accessibility'
import { Agents } from './agents'
import { Ambulance } from './ambulance'
import { App } from './app'
import { Atlassian } from './atlassian'
import { Back } from './back'
import { Badge } from './badge'
import { Bandaid } from './bandaid'
import { Bank } from './bank'
import { Bed } from './bed'
import { BookmarkFilled } from './bookmark-filled'
import { Bookmark } from './bookmark'
import { Building } from './building'
import { Calculator } from './calculator'
import { Calendar } from './calendar'
import { Camera } from './camera'
import { Chat } from './chat'
import { Check } from './check'
import { Checkmark } from './checkmark'
import { ChevronDown } from './chevron-down'
import { ChevronLeft } from './chevron-left'
import { ChevronRight } from './chevron-right'
import { ChevronRightThin } from './chevron-right-thin'
import { ChevronUp } from './chevron-up'
import { Circle } from './circle'
import { Columns } from './columns'
import { Computer } from './computer'
import { Copy } from './copy'
import { Coverage } from './coverage'
import { CreditCard } from './credit-card'
import { Crop } from './crop'
import { Csv } from './csv'
import { Customer } from './customer'
import { Dashboard } from './dashboard'
import { Directions } from './directions'
import { Doctor } from './doctor'
import { Document } from './document'
import { Dollar } from './dollar'
import { Down } from './down'
import { Download } from './download'
import { Edit } from './edit'
import { Email } from './email'
import { Eob } from './eob'
import { Exclamation } from './exclamation'
import { Expand } from './expand'
import { EyeFilled } from './eye-filled'
import { Fax } from './fax'
import { Female } from './female'
import { Filter } from './filter'
import { Fire } from './fire'
import { FlashOff } from './flash-off'
import { FlashOn } from './flash-on'
import { Forward } from './forward'
import { Gift } from './gift'
import { Group } from './group'
import { Headset } from './headset'
import { Heart } from './heart'
import { Help } from './help'
import { Hide } from './hide'
import { Hospital } from './hospital'
import { Image } from './image'
import { Imaging } from './imaging'
import { Info } from './info'
import { InsuranceCard } from './insurance-card'
import { Lab } from './lab'
import { Lightbulb } from './lightbulb'
import { Link } from './link'
import { List } from './list'
import { Loading } from './loading'
import { Location } from './location'
import { Lock } from './lock'
import { Logout } from './logout'
import { Male } from './male'
import { Map } from './map'
import { Mask } from './mask'
import { Medkit } from './medkit'
import { Menu } from './menu'
import { Merge } from './merge'
import { Minimize } from './minimize'
import { Minus } from './minus'
import { Money } from './money'
import { More } from './more'
import { Needle } from './needle'
import { NoImageFound } from './no-image-found'
import { NoSwipe } from './no-swipe'
import { OccupationalTherapy } from './occupational-therapy'
import { Office } from './office'
import { On } from './on'
import { Pause } from './pause'
import { Pdf } from './pdf'
import { Percentage } from './percentage'
import { Phone } from './phone'
import { PhotoStack } from './photo-stack'
import { PhysicalTherapist } from './physical-therapist'
import { Pin } from './pin'
import { Pinned } from './pinned'
import { Pivot } from './pivot'
import { Plane } from './plane'
import { Play } from './play'
import { Plus } from './plus'
import { PriceShield } from './priceShield'
import { Print } from './print'
import { Rx } from './rx'
import { Question } from './question'
import { Receipt } from './receipt'
import { Refresh } from './refresh'
import { Refund } from './refund'
import { Reports } from './reports'
import { Restaurant } from './restaurant'
import { Rewind } from './rewind'
import { RotateClockwise } from './rotate-clockwise'
import { Scissors } from './scissors'
import { Search } from './search'
import { Security } from './security'
import { Segment } from './segment'
import { Send } from './send'
import { Settings } from './settings'
import { Share } from './share'
import { Sidecar } from './sidecar'
import { Shirt } from './shirt'
import { Sort } from './sort'
import { SortAsc } from './sort-asc'
import { SortDesc } from './sort-desc'
import { Sorted } from './sorted'
import { Spine } from './spine'
import { Split } from './split'
import { Star } from './star'
import { StarEmpty } from './starEmpty'
import { StarSixPoint } from './starSixPoint'
import { StarSixPointEmpty } from './starSixPointEmpty'
import { Surgery } from './surgery'
import { Switch } from './switch'
import { Telehealth } from './telehealth'
import { ThumbsDown } from './thumbs-down'
import { ThumbsUp } from './thumbs-up'
import { Thumbtack } from './thumbtack'
import { Tooltip } from './tooltip'
import { Tooth } from './tooth'
import { Trash } from './trash'
import { Sparkles } from './sparkles'
import { Unlink } from './unlink'
import { Unlock } from './unlock'
import { Up } from './up'
import { Upload } from './upload'
import { UrgentCare } from './urgent-care'
import { Vector } from './vector'
import { Verify } from './verify'
import { Video } from './video'
import { Write } from './write'
import { X } from './x'
import { Zoom } from './zoom'

const serviceIcons: { [key: string]: any } = {
  accessibility: Accessibility,
  agents: Agents,
  ambulance: Ambulance,
  app: App,
  atlassian: Atlassian,
  back: Back,
  badge: Badge,
  bandaid: Bandaid,
  bank: Bank,
  bed: Bed,
  bookmarkFilled: BookmarkFilled,
  bookmark: Bookmark,
  building: Building,
  calculator: Calculator,
  calendar: Calendar,
  camera: Camera,
  chat: Chat,
  check: Check,
  checkmark: Checkmark,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronRightThin: ChevronRightThin,
  chevronUp: ChevronUp,
  circle: Circle,
  columns: Columns,
  computer: Computer,
  copy: Copy,
  coverage: Coverage,
  creditCard: CreditCard,
  crop: Crop,
  csv: Csv,
  customer: Customer,
  dashboard: Dashboard,
  directions: Directions,
  doctor: Doctor,
  document: Document,
  dollar: Dollar,
  down: Down,
  download: Download,
  edit: Edit,
  email: Email,
  eob: Eob,
  exclamation: Exclamation,
  expand: Expand,
  eyeFilled: EyeFilled,
  fax: Fax,
  female: Female,
  filter: Filter,
  fire: Fire,
  flashOff: FlashOff,
  flashOn: FlashOn,
  forward: Forward,
  gift: Gift,
  group: Group,
  headset: Headset,
  heart: Heart,
  help: Help,
  hide: Hide,
  hospital: Hospital,
  image: Image,
  imaging: Imaging,
  info: Info,
  insuranceCard: InsuranceCard,
  lab: Lab,
  lightbulb: Lightbulb,
  link: Link,
  list: List,
  loading: Loading,
  location: Location,
  lock: Lock,
  logout: Logout,
  male: Male,
  mask: Mask,
  map: Map,
  medkit: Medkit,
  menu: Menu,
  merge: Merge,
  minimize: Minimize,
  minus: Minus,
  money: Money,
  more: More,
  needle: Needle,
  noImageFound: NoImageFound,
  noSwipe: NoSwipe,
  occupationalTherapy: OccupationalTherapy,
  office: Office,
  on: On,
  pause: Pause,
  pdf: Pdf,
  percentage: Percentage,
  phone: Phone,
  photoStack: PhotoStack,
  physicalTherapist: PhysicalTherapist,
  pin: Pin,
  pinned: Pinned,
  pivot: Pivot,
  plane: Plane,
  play: Play,
  plus: Plus,
  priceShield: PriceShield,
  print: Print,
  rx: Rx,
  question: Question,
  receipt: Receipt,
  refresh: Refresh,
  refund: Refund,
  reports: Reports,
  restaurant: Restaurant,
  rewind: Rewind,
  rotateClockwise: RotateClockwise,
  scissors: Scissors,
  search: Search,
  security: Security,
  segment: Segment,
  send: Send,
  settings: Settings,
  share: Share,
  shirt: Shirt,
  sidecar: Sidecar,
  sort: Sort,
  sortAsc: SortAsc,
  sortDesc: SortDesc,
  sorted: Sorted,
  spine: Spine,
  split: Split,
  star: Star,
  starEmpty: StarEmpty,
  starSixPoint: StarSixPoint,
  starSixPointEmpty: StarSixPointEmpty,
  surgery: Surgery,
  switch: Switch,
  telehealth: Telehealth,
  thumbsDown: ThumbsDown,
  thumbsUp: ThumbsUp,
  thumbtack: Thumbtack,
  tooltip: Tooltip,
  tooth: Tooth,
  trash: Trash,
  sparkles: Sparkles,
  unlock: Unlock,
  up: Up,
  unlink: Unlink,
  upload: Upload,
  urgentCare: UrgentCare,
  vector: Vector,
  verify: Verify,
  video: Video,
  write: Write,
  x: X,
  zoom: Zoom,
}

export default serviceIcons
